import React, { Fragment } from "react";
import { Outlet } from 'react-router-dom'
import Layout from "../../../layout/Layout";
import LayoutSetting, {
  ILayoutSetting,
} from "../../../layout/setting/LayoutSetting";

export default function UserLayoutSetting() {
  const menu: ILayoutSetting = {
    title: "Setting Spin",
    menus: [
      { id: 1, text: "User", to: "/setting-user" },
      { id: 2, text: "Tambah User", to: "/setting-user/form" },
      { id: 3, text: "Log User", to: "/setting-user/log" }
    ],
  };

  return (
    <Fragment>
      <Layout hideOutlet={true}></Layout>
      <div style={{ display: "flex" }}>
        <LayoutSetting menus={menu.menus} title={menu.title}></LayoutSetting>
        <div style={{ padding: 20, width: "100%" }}>
          <Outlet></Outlet>
        </div>
      </div>
    </Fragment>
  );
}
